<div class="flex flex-col items-center justify-center text-center w-full h-full px-8">

  <!-- Large 404 Number — Architectural Typographic Anchor -->
  <div class="relative mb-8 select-none leading-none">
    <span
      class="text-[12rem] lg:text-[16rem] font-black tracking-tighter text-foreground/5 dark:text-white/[0.04] pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 whitespace-nowrap">
      404
    </span>
    <!-- Icon centered over number -->
    <div
      class="relative flex items-center justify-center w-24 h-24 rounded-[2rem] bg-primary/8 border border-primary/10 shadow-lg shadow-primary/10 mx-auto">
      <iconify-icon icon="mdi:tooth-outline" width="48" height="48" class="text-primary"></iconify-icon>
      <div class="absolute bottom-3 right-3 w-2.5 h-2.5 rounded-full bg-red-500 animate-ping"></div>
      <div class="absolute bottom-3 right-3 w-2.5 h-2.5 rounded-full bg-red-500"></div>
    </div>
  </div>

  <!-- Eyebrow tag -->
  <div class="inline-flex items-center gap-2 mb-6 text-primary opacity-80">
    <div class="w-6 h-[1.5px] bg-primary/40"></div>
    <span class="text-[13px] font-black uppercase tracking-[0.4em]">Error 404</span>
    <div class="w-6 h-[1.5px] bg-primary/40"></div>
  </div>

  <!-- Main heading -->
  <h1 class="text-4xl lg:text-6xl font-black tracking-tighter leading-none text-foreground mb-6 uppercase">
    Página <br>
    <span class="text-primary text-3xl lg: text-5xl">No Encontrada</span>
  </h1>

  <!-- Subtitle description -->
  <p
    class="text-text-muted dark:text-slate-500 font-bold text-xs lg:text-[11px] leading-relaxed max-w-sm border-l-2 border-primary/10 pl-5 text-left mb-10">
    Esta sección del portal no está disponible. Regresa al inicio para continuar administrando tu clínica con DENTIUM
    SYS.
  </p>

  <!-- CTA Buttons -->
  <div class="flex flex-wrap justify-center items-center gap-8">
    <app-button (btnClick)="goBack()" variant="link" size="lg" iconLeft="mdi:arrow-left"
      class="uppercase tracking-[0.2em] font-black " color="text-base">
      Volver al Inicio
    </app-button>

    <app-button (btnClick)="goToLogin()" variant="link" size="lg" iconRight="mdi:arrow-right"
      class="uppercase tracking-[0.2em] font-black">
      Portal de Ingreso
    </app-button>

  </div>

  <!-- Medical ambient decoration -->
  <div class="mt-16 opacity-[0.18] w-full max-w-md pointer-events-none">
    <svg viewBox="0 0 300 40" xmlns="http://www.w3.org/2000/svg" class="w-full h-auto text-primary dark:text-white">
      <path d="M0 20h30l8-14 14 28 8-14h60l8 12 8-22 8 10h60l8 8 8-16 8 8h30" fill="none" stroke="currentColor"
        stroke-width="1.5" stroke-dasharray="4 3" />
    </svg>
  </div>

  <!-- Version tag -->
  <p class="mt-8 text-[9px] font-black tracking-[0.3em] text-text-muted uppercase opacity-60">
    DENTIUM SYS Platform v1.0.4
  </p>
</div>